__turbopack_context__.v({
  "button": "Chip-module-scss-module__1pr7bG__button",
  "chip": "Chip-module-scss-module__1pr7bG__chip",
  "chipActive": "Chip-module-scss-module__1pr7bG__chipActive",
  "chipMd": "Chip-module-scss-module__1pr7bG__chipMd",
  "chipSm": "Chip-module-scss-module__1pr7bG__chipSm",
  "fade-in": "Chip-module-scss-module__1pr7bG__fade-in",
  "no-transform": "Chip-module-scss-module__1pr7bG__no-transform",
  "removeButton": "Chip-module-scss-module__1pr7bG__removeButton",
  "rotate": "Chip-module-scss-module__1pr7bG__rotate",
});
